<template>
  <div>
    <HomeHeader 
      @about-click="handleAboutClick"
      @employers-click="handleEmployersClick"
      @start-work-click="handleStartWorkClick"
    />

    <HeroBanner
      @start-work-click="handleStartWorkClick"
      @advantages-click="handleAdvantagesClick"
    />
    <div ref="whoWeAreBlock">
      <WhoWeAre />
    </div>
    <WhereWeAre />
    <HowWeWork ref="howWeWorkBlock" />
    <AppleDownloadDrawer />
    <Footer />
  </div>
</template>

<script setup>
import { ref } from "vue";
import { useRouter } from "vue-router";

import HomeHeader from "../components/HomeHeader.vue";
import HeroBanner from "../components/HeroBanner.vue";
import WhoWeAre from "../components/WhoWeAre.vue";
import WhereWeAre from "../components/WhereWeAre.vue";
import HowWeWork from "../components/HowWeWork.vue";
import Footer from "../components/Footer.vue";
import AppleDownloadDrawer from "../components/AppleDownloadDrawer.vue";

const router = useRouter();
const howWeWorkBlock = ref(null);
const whoWeAreBlock = ref(null);

const handleAboutClick = () => {
  if (whoWeAreBlock.value) {
    whoWeAreBlock.value.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  }
};

const handleAdvantagesClick = () => {
  howWeWorkBlock.value?.$el?.scrollIntoView({ behavior: "smooth" });
};

const handleEmployersClick = () => {
  router.push("/advantages");
};

const handleStartWorkClick = () => {
  router.push("/login");
};

</script>